module.exports = __webpack_public_path__ + "img/w3_circle_light.12ea116a.png";